import React, { useState, useEffect, useRef } from 'react';
import AddPermissionModal from '../components/modals/AddPermissionModal';
import EditPermissionModal from '../components/modals/EditPermissionModal';
import DeletePermissionModal from '../components/modals/DeletePermissionModal';
import {
  getPermissionsTypes,
  getUsersWithPermissions,
  updatePermissions,
} from '../services/permissionsService';
import { useTranslation } from 'react-i18next';
import { showSuccessToast } from '../../../utils/toastHelper';
import { deleteUser } from '../../auth/services/authService';
import { usePermissions } from '../../../contexts/PermissionsContext';
import { useAuth } from '../../../contexts/AuthContext';
import Loader from '../../../components/Loader';

export default function Permissions() {
  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [users, setUsers] = useState([]);
  const [permissionsTypes, setPermissionsTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user: loggedInUser } = useAuth();
  const { permissions } = usePermissions();
  const [searchQuery, setSearchQuery] = useState('');

  const { t } = useTranslation('permissions');
  // const [error, setError] = useState(null);
  const modalRef = useRef(null);
  const fetchData = async () => {
    setLoading(true);
    // setError(null);

    try {
      // const data = await getPermissionsTypes();
      const [usersData, permissionsData] = await Promise.all([
        getUsersWithPermissions({ search: searchQuery, excludeSelf: 1 }),
        getPermissionsTypes(),
      ]);
      if (usersData.users) {
        setUsers(usersData.users);
      }
      if (permissionsData.permissions) {
        setPermissionsTypes(permissionsData.permissions);
      }
    } catch (err) {
      // setError('Failed to load permissions');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchData();
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);
  const refreshUsers = async () => {
    setLoading(true);
    try {
      const usersData = await getUsersWithPermissions();
      if (usersData.users) {
        setUsers(usersData.users);
      }
    } catch (err) {
      console.error('Failed to refresh users:', err);
    }
    setLoading(false);
  };
  console.log('users: ', users);
  // console.log('permissionsssssssss: ',permissions)

  const handleOpenModal = (modalType, user) => {
    setModalData(user);
    if (modalType === 'add') {
      setAddModalOpen(true);
    } else if (modalType === 'edit') {
      setEditModalOpen(true);
    } else if (modalType === 'delete') {
      setDeleteModalOpen(true);
    }
  };
  const handleCloseModal = (modalType) => {
    console.log('handle on close ', modalType);
    // setModalData(user)
    if (modalType === 'add') {
      setAddModalOpen(false);
    } else if (modalType === 'edit') {
      setEditModalOpen(false);
    } else if (modalType === 'delete') {
      setDeleteModalOpen(false);
    }
  };
  const handleEditPermissionSubmit = async (dataToSend) => {
    try {
      console.log('data to send', dataToSend);
      const response = await updatePermissions(dataToSend);
      if (response.success) {
        console.log(response.permissions);
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.id === dataToSend.user_id
              ? { ...user, permissions: response.permissions }
              : user
          )
        );
        showSuccessToast(response.message);
        // modalRef.current.close();
        // closeRef.current.click();
        handleCloseModal('edit');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const handleDeleteUser = async (id) => {
    const user = await deleteUser(id);
    console.log('user delete', user);
    handleCloseModal('delete');
    handleCloseModal('edit');
    if (user.success) {
      // Update the users list by removing the user with the specified id
      setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id));
    }
  };
  return (
    <div>
      <main id="permissions" className="permissions">
        <section className="main-section">
          <section className="data">
            <div className="row">
              <div className="col-sm-6">
                <div className="left">
                  <h1>{t('PERMISSIONS')}</h1>
                  <div className="input-card">
                    <img src="images/search-icon.svg" alt="" />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder={t('SEARCH')}
                    />
                  </div>
                </div>
              </div>
              {permissions?.USER_PERMISSIONS?.edit_permission === 1 && (
                <div className="col-sm-6 position-relative">
                  <div className="right">
                    <button
                      className="add-btn"
                      // data-bs-toggle="modal"
                      // data-bs-target="#permissions-add"
                      onClick={() => handleOpenModal('add', {})}
                    >
                      + {t('ADD')}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </section>
          <div className="table-outer">
            <table className="table">
              <thead>
                <tr className="t-heading">
                  <th className="users">
                    <h5>{t('USERS')}</h5>
                  </th>
                  <th className="permission-type">
                    <h5>{t('PERMISSIONSTYPE')}</h5>
                  </th>
                  <th className="permission">
                    <h5>{t('PERMISSIONS')}</h5>
                  </th>
                  {permissions?.USER_PERMISSIONS?.edit_permission === 1 && (
                    <th className="action">
                      <h5>{t('ACTION')}</h5>
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <Loader />
                ) : (
                  <>
                    {users.length < 1 ? (
                      <tr>
                        <td colSpan="100%" className="text-center py-4">
                          {t('NORECORDAVAILABLE')}
                        </td>
                      </tr>
                    ) : (
                      users
                        .filter((user) => user.id !== loggedInUser.id)
                        .map((user, index) => (
                          <tr key={index}>
                            <td className="users">
                              <div className="profile">
                                <span>
                                  <img src="images/empty-user.png" alt="" />
                                </span>
                                <div className="profile-text">
                                  <h5>{user.name}</h5>
                                  <h6>{user.email}</h6>
                                </div>
                              </div>
                            </td>
                            <td className="permission-type">
                              <ul>
                                {permissionsTypes.map(
                                  (permissionType, permissionTypeIndex) => (
                                    <li key={permissionTypeIndex}>
                                      <h5>{t(permissionType.key)}</h5>
                                    </li>
                                  )
                                )}
                              </ul>
                            </td>
                            <td className="permission">
                              <div className="checkbox-container">
                                <ul>
                                  {permissionsTypes.map(
                                    (permissionType, permissionTypeIndex) => {
                                      const userPermission =
                                        user.permissions.find(
                                          (perm) =>
                                            perm?.permission_type?.id ===
                                            permissionType?.id
                                        );

                                      return (
                                        <li key={permissionTypeIndex}>
                                          {/* <label className="custom-checkbox">
                                        <input
                                          type="checkbox"
                                          checked={
                                            userPermission?. ===
                                              1 || false
                                          }
                                          readOnly
                                        />
                                        <span className="checkmark"></span>
                                        <span className="label-text">
                                          {t("ADD")}
                                        </span>
                                      </label> */}
                                          <label className="custom-checkbox">
                                            <input
                                              type="checkbox"
                                              checked={
                                                userPermission?.view_permission ===
                                                  1 || false
                                              }
                                              readOnly
                                            />
                                            <span className="checkmark"></span>
                                            <span className="label-text">
                                              {t('VIEW')}
                                            </span>
                                          </label>
                                          <label className="custom-checkbox">
                                            <input
                                              type="checkbox"
                                              checked={
                                                userPermission?.edit_permission ===
                                                  1 || false
                                              }
                                              readOnly
                                            />
                                            <span className="checkmark"></span>
                                            <span className="label-text">
                                              {t('CHANGE')}
                                            </span>
                                          </label>
                                        </li>
                                      );
                                    }
                                  )}
                                </ul>
                              </div>
                            </td>
                            {permissions?.USER_PERMISSIONS?.edit_permission ===
                              1 && (
                              <td className="action">
                                <button
                                  className="edit"
                                  onClick={() => handleOpenModal('edit', user)}
                                >
                                  <img src="images/green-edit.svg" alt="" />
                                </button>
                                <button
                                  className="delete"
                                  onClick={() =>
                                    handleOpenModal('delete', user)
                                  }
                                >
                                  <img src="images/red-delete.svg" alt="" />
                                </button>
                              </td>
                            )}
                          </tr>
                        ))
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </main>

      {/* {isAddModalOpen && <AddPermissionModal onClose={() => setAddModalOpen(false)} />}
        {isEditModalOpen && <EditPermissionModal onClose={() => setEditModalOpen(false)} />}
        {isDeleteModalOpen && <DeletePermissionModal onClose={() => setDeleteModalOpen(false)} />} */}
      <AddPermissionModal
        permissionsTypes={permissionsTypes}
        isOpen={isAddModalOpen}
        onClose={handleCloseModal}
        refreshUsers={refreshUsers}
      />
      <EditPermissionModal
        modalData={modalData}
        handleEditPermissionSubmit={handleEditPermissionSubmit}
        permissionsTypes={permissionsTypes}
        isOpen={isEditModalOpen}
        onClose={handleCloseModal}
        isDeleteOpen={isDeleteModalOpen}
        deleteUser={handleDeleteUser}
        handleOpenModal={handleOpenModal}
      />
      <DeletePermissionModal
        modalData={modalData}
        isOpen={isDeleteModalOpen}
        onClose={handleCloseModal}
        deleteUser={handleDeleteUser}
      />
    </div>
  );
}
